import { DEFAULT_LANG_CODE, PLP_CATEGORY } from 'shared/constants.ts';
import { getLanguageFromPath } from './languageUtils.ts';

type ProductBreadcrumbMapping = {
	[Key: string]: string;
};

async function fetchProductBreadcrumbMapping() {
	const sessionStorageKey = 'product-breadcrumb-mapping';
	const breadcrumbMappingString = sessionStorage.getItem(sessionStorageKey);
	if (breadcrumbMappingString) {
		return JSON.parse(breadcrumbMappingString) as ProductBreadcrumbMapping;
	}

	const response = await fetch('/product-breadcrumb-mapping.json');
	if (!response.ok) {
		console.error('Failed to fetch product-breadcrumb-mapping');
		return {} as ProductBreadcrumbMapping;
	}

	const responseBody = JSON.parse(await response.text()) as {
		data: Array<{
			// eslint-disable-next-line @typescript-eslint/naming-convention
			'PLP Category': string;
			// eslint-disable-next-line @typescript-eslint/naming-convention
			'Breadcrumb Path': string;
		}>;
	};

	if (!responseBody.data) {
		console.error(
			'Failed to fetch product-breadcrumb-mapping, response data is empty',
		);
		return {} as ProductBreadcrumbMapping;
	}

	const mappings = responseBody.data.reduce((acc, item) => {
		acc[item['PLP Category']] = item['Breadcrumb Path'];
		return acc;
	}, {} as ProductBreadcrumbMapping);
	window.sessionStorage.setItem(sessionStorageKey, JSON.stringify(mappings));
	return mappings;
}

export async function getProductBreadcrumbPath() {
	const plpCategory = sessionStorage.getItem(PLP_CATEGORY);
	if (!plpCategory) return;

	const productBreadcrumbMapping = await fetchProductBreadcrumbMapping();
	let returnUrl = productBreadcrumbMapping[plpCategory];

	if (returnUrl) {
		returnUrl = returnUrl.startsWith('/') ? returnUrl : `/${returnUrl}`;
		const lang = getLanguageFromPath() || DEFAULT_LANG_CODE;
		return `/${lang}${returnUrl}`;
	}
}
